<template>
  <div class="Pie">
    <div ref="pieChart" id="statistics" class="chart"></div>
  </div>
</template>

<script>
import * as echarts from "echarts";
export default {
  props: {
    list: {
      type: Object,
    },
    sevenlist: {
      type: Array,
    },
  },
  data() {
    return {
      pieChart: null,
      optionPie: {
        tooltip: {
          trigger: "item",
          formatter: "{a} <br/>{b}: {c} ({d}%)",
        },
        legend: {
          top: "2%",
          left: "center",
        },
        series: [
          {
            name: "支付信息",
            type: "pie",
            radius: ["50%", "70%"],
            avoidLabelOverlap: false,
            minAngle: 5, // 添加最小角度属性
            label: {
              show: false,
              position: "center",
            },
            emphasis: {
              label: {
                show: true,
                fontSize: "30",
                fontWeight: "bold",
              },
            },
            labelLine: {
              show: false,
            },
            data: [],
          },
        ],
      },
    };
  },
  methods: {
    renderPieChart(data) {
      // this.pieChart = echarts.init(document.getElementById('piedataChart'))
      if (this.$refs.pieChart) {
        this.pieChart = echarts.init(this.$refs.pieChart);
        this.pieChart.setOption(data);
      } else {
        console.error("Cannot find pieChart element.");
      }
    },
  },
  watch: {
    list() {
      let bar = this.optionPie;
      bar.series[0].data = this.list.payMapList;
      this.renderPieChart(bar);
    },
    sevenlist() {
      let bar = this.optionPie;
      bar.series[0].data = this.sevenlist;
      this.renderPieChart(bar);
    },
  },
  created() {},
  mounted() {
    if (this.list) {
      let bar = this.optionPie;
      bar.series[0].data = this.list.payMapList;
      this.renderPieChart(bar);
    }
    if (this.sevenlist) {
      let bar = this.optionPie;
      bar.series[0].data = this.sevenlist;
      this.renderPieChart(bar);
    }
    
  },
  beforeDestroy() {
    if (this.pieChart) {
      this.pieChart.clear();
    }
  },
};
</script>

<style scoped lang="scss">
.Pie {
  display: flex;
  justify-content: center;
  width: 500px;
  height: 300px;
  margin-top: 20px;
  margin: 0 auto;

  .chart {
    width: 500px;
    height: 300px;
  }
}
</style>